import MuiButton from '@mui/material/Button';
import clsx from 'clsx';
import type { ComponentProps } from 'react';

export const InvisibleButtonLink = (
  props: ComponentProps<typeof MuiButton>,
) => {
  return (
    <MuiButton
      {...props}
      className={clsx(props.className)}
      disableRipple
      disableElevation
      sx={{
        p: 0,
        height: 'auto',
        display: 'inline',
        verticalAlign: 'baseline',
        bgcolor: 'transparent',
        fontWeight: 'normal',
        cursor: 'pointer',
        textDecorationThickness: 'from-font',
        '&:hover': { bgcolor: 'transparent', textDecoration: 'underline' },
      }}
    />
  );
};
